import axios from "axios";
import Response from "../response";
import { errCodes } from "../response/errors";
import { BLITZ_CI_AUTH, COMMISSIONS_API_BASE_URL } from "../../utils/constants";

class Sites {
  constructor() {
    this.baseUrl = COMMISSIONS_API_BASE_URL;
    this.endpoint = "data/sites";
    this.url = `${this.baseUrl}/${this.endpoint}`;
    this.headers = {
      'Content-Type': 'application/json',
      'Authorization': '',
    };
  }

  #checkSession() {
    this.accessToken = sessionStorage.getItem(BLITZ_CI_AUTH);
    this.headers['Authorization'] = `Bearer ${this.accessToken}`;
  }

  async getAllSites() {
    this.#checkSession();
    try {
      const response = await axios.get(`${this.url}`, { headers: this.headers });
      if (response.status === 200 && Array.isArray(response.data)) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.NotFound);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }

  async getSiteServices(carrierID) {
    this.#checkSession();
    try {
      const response = await axios.get(`${this.url}/${carrierID}/services`, { headers: this.headers });
      if (response.status === 200 && Array.isArray(response.data)) {
        return Response.create(response.data, true);
      }
      return Response.create({}, false, {}, errCodes.NotFound);
    } catch (error) {
      return Response.create({}, false, error, errCodes.Internal);
    }
  }
}
export default Sites;
